import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import LeadForm from "../components/LeadForm";
import StaticMap from "../components/StaticMap";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const PHONE = "450-736-0748";

export default function Contact() {
  const { t, pick } = useI18n();
  useSeo(t("nav.contact"), "Contactez la Résidence Doux Instants à Laval (Auteuil) : téléphone 450-736-0748, courriel et formulaire de visite.");
  const { data: settings = {} } = useContent("settings");

  return (
    <>
      <PageHero eyebrow={t("nav.contact")} title={t("forms.visitTitle")}
        subtitle="Planifiez une visite ou écrivez-nous. Nous serons ravis de vous accueillir." />

      <Section tone="surface">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <div className="space-y-4" data-testid="contact-coordinates">
              <a href={`tel:${PHONE}`} className="flex items-center gap-3 text-lg" data-testid="contact-phone">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#2A9D8F]/10"><Phone className="h-5 w-5 text-[#2A9D8F]" /></span>
                {PHONE}
              </a>
              <a href="mailto:doux.instants.senc@gmail.com" className="flex items-center gap-3 text-lg">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#2A9D8F]/10"><Mail className="h-5 w-5 text-[#2A9D8F]" /></span>
                doux.instants.senc@gmail.com
              </a>
              <p className="flex items-center gap-3 text-lg">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#2A9D8F]/10"><MapPin className="h-5 w-5 text-[#2A9D8F]" /></span>
                4825, rue Cyrille Delage, Laval (Auteuil), QC
              </p>
              <p className="flex items-center gap-3 text-lg">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#2A9D8F]/10"><Clock className="h-5 w-5 text-[#2A9D8F]" /></span>
                {pick(settings.hours)}
              </p>
            </div>
            <div className="mt-6">
              <h2 className="mb-3 font-display text-2xl">{t("map.title")}</h2>
              <StaticMap />
            </div>
          </div>

          <div className="rounded-3xl border border-black/5 bg-[#F9F6F0] p-6 sm:p-8" data-testid="contact-form-card">
            <h2 className="font-display text-2xl">{t("forms.visitTitle")}</h2>
            <div className="mt-5"><LeadForm kind="visit" /></div>
          </div>
        </div>
      </Section>

      <Section tone="base" data-testid="general-contact-section">
        <div className="mx-auto max-w-2xl">
          <h2 className="font-display text-2xl">{t("forms.contactTitle")}</h2>
          <div className="mt-5 rounded-3xl border border-black/5 bg-white p-6 sm:p-8">
            <LeadForm kind="contact" />
          </div>
        </div>
      </Section>
    </>
  );
}
